import { z } from 'zod';

export const subsetFormSchema = z.object({
  name: z.string().trim().min(1, { message: 'Subset name is required' }),
  legalIssues: z
    .string()
    .trim()
    .min(1, { message: 'Subset issues are required' })
    .max(2000, { message: 'Issues are limited to 2000 characters' }),
});

export type SubsetFormData = z.infer<typeof subsetFormSchema>;
